const APP_ROUTES = {
  HOME: '/',
  DASHBOARD: {
    HOME: '/dashboard',
    INTRO: '/dashboard/intro'
  },
  ERROR: {
    REGION: '/error/region',
    '404': '/error/404'
  }
} as const

const ADAPTIVE_AUTH_EMAIL = '/adaptive-authentication/email' as const
const PRIVACY_NOTICES_SERVICES_PATH = '/policies/privacy-notices/services'
const PRIVACY_POLICIES_SERVICES_PATH = '/policies/privacy-policies/services'

const RouterConstants = {
  PRIVACY_NOTICES_SERVICES_APP_INFO: PRIVACY_NOTICES_SERVICES_PATH + '/:appId/latest',
  PRIVACY_POLICIES_SERVICES_APP_INFO: PRIVACY_POLICIES_SERVICES_PATH + '/:appId/latest'
} as const

export { APP_ROUTES, ADAPTIVE_AUTH_EMAIL, RouterConstants }
